const sameNumber = (a, b) => String(a ?? "").trim().toLowerCase() === String(b ?? "").trim().toLowerCase();

export const membershipRequestPayload = ({ player, memberNumber, startMonth, conflict, keeperId, replacement }) => {
  const payload = { roster_member_id: player.id };
  if (startMonth) payload.start_month = startMonth;
  const number = conflict ? conflict.number : String(memberNumber ?? "").trim();
  if (number) payload.member_number = number;
  if (conflict) {
    payload.member_number_keeper_id = keeperId;
    const trimmed = String(replacement ?? "").trim();
    if (trimmed) payload.replacement_member_number = trimmed;
  }
  return payload;
};

/**
 * Who gives the contested number up, and what leaving the replacement blank means for them.
 * Returns null when several holders lose it at once; they all get the next free number.
 */
export const replacementTarget = ({ player, conflict, keeperId }) => {
  const losers = keeperId === player.id ? conflict.holders : [player];
  if (losers.length !== 1) return null;

  const loser = losers[0];
  if (loser.id === player.id && player.member_number && !sameNumber(player.member_number, conflict.number)) {
    return { loser, helpKey: "gestion.accountFinance.replacementKeepsCurrent" };
  }
  return { loser, helpKey: "gestion.accountFinance.replacementAuto" };
};
